import { GOOGLE_SORT_OPTIONS } from 'utils/metrics';
import GraphNav from './GraphNav';
import { useGoogleData } from 'utils/hooks';

const defaultSortOptions = [
    GOOGLE_SORT_OPTIONS.volume,
    GOOGLE_SORT_OPTIONS.absoluteGrowth,
    GOOGLE_SORT_OPTIONS.YoY,
    GOOGLE_SORT_OPTIONS.QoQ_increase,
    GOOGLE_SORT_OPTIONS.QoQ,
    GOOGLE_SORT_OPTIONS.MoM_increase,
    GOOGLE_SORT_OPTIONS.MoM,
];

function GoogleGraphNav({
    ids,
    categoryId,
    countryId,
    controller = null,
    ...restProps
}) {
    const { data: items } = useGoogleData({
        enabled: !!(ids && countryId),
        data: {
            categories: ids || null,
            countries: countryId ? [countryId] : null,
        },
        paginateBy: 'categories',
        includeNoDataItems: false,
        controller,
    });

    const isLoading =
        !items ||
        items.some(({ fetching, fetchingData }) => fetching || fetchingData);

    return (
        <GraphNav
            {...restProps}
            data={items}
            isLoading={isLoading}
            categoryId={categoryId}
            sortOptions={defaultSortOptions}
            primaryMetric={defaultSortOptions[0]}
            defaultSecondaryMetric={GOOGLE_SORT_OPTIONS.YoY}
        />
    );
}

export default GoogleGraphNav;
